import { getLeadEnquiries } from "../api/lead-enquiries/getLeadEnquiries";

const THIRTY_MINUTES = 1000 * 60 * 30;

/**
 * Query functions for lead enquiries
 */
const leadEnquiriesQueries = {
  /**
   * Query for fetching lead enquiries for a specific lead
   * @param {string} leadId - The ID of the lead to fetch enquiries for
   * @param {Axios} axios - The axios instance to use
   * @param {Object} options - Optional parameters for the request
   * @returns {Object} - Query configuration
   */
  leadEnquiries: (leadId, axios, options = {}) => ({
    queryKey: ['leadEnquiries', leadId, options],
    queryFn: () => getLeadEnquiries(axios, leadId, options),
    staleTime: THIRTY_MINUTES,
    refetchOnWindowFocus: false,
    refetchInterval: THIRTY_MINUTES,
    enabled: !!leadId,
  }),
};

export default leadEnquiriesQueries;
